import { render } from "./SocialItem.vue?vue&type=template&id=5097c3f6&scoped=true"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"

import "./SocialItem.vue?vue&type=style&index=0&id=5097c3f6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5097c3f6"]])

export default __exports__